import styles from './DefendantPlea.module.css';

const DefendantPlea = () => {
  return (
    <div className={styles['root-component']}>
      <DefendantPleaTopHalf />
      <DefendantPleaBottomText />
    </div >
  );
}

const DefendantPleaTopHalf = () => {
  return (
    //convert this to a grid
    <div className={styles['back-top-half']}>
      <InstructionsBox />
      <DefendantInformation />
    </div>
  )
}

const InstructionsBox = () => {
  return (
    <div className={styles['back-half-instructions']}>
      <div className={styles['text-padding']}>
        <SignHere />
        <p className={styles['print-p']}>2. Mark (&quot;X&quot;) your plea below:</p>
        <CheckboxWithText>
          <span className={styles['large-text']}>ACCEPT THE PENALTIES <br />WITHOUT A HEARING</span>
        </CheckboxWithText>
        <CheckboxWithText>
          <span className={styles['large-text']}>REQUEST A HEARING</span>
        </CheckboxWithText>
        <p className={`${styles['small-text']} ${styles['no-margin']}`}>
          If English is not your preferred language, you have the right to<br />
          request an interpreter at no cost to you:<br />
          Preferred Language/Dialect:________________________________<br />
          <sup>*</sup> Friends or family cannot interpret for you in a court hearing
        </p>
        <p className={styles['print-p']}>3. Deliver your plea in person or by mail to:</p>
        <div className={styles['deliver-to-address']}>
          <p className={`${styles['no-margin']} ${styles['print-p']}`}>Judicial Bureau</p>
          <p className={`${styles['no-margin']} ${styles['print-p']}`}>POB 607, White River Jct., VT 05001</p>
        </div>
        <div>
          <p className={`${styles['large-bold-text']} ${styles['no-margin']}`}>
            <span className={`${styles['large-bold-text']} ${styles.underline}`}>OR </span>
            PAY ONLINE and avoid mailing.<br />
            www.vermontjudiciary.org
          </p>
        </div>
      </div>
    </div>
  )
}

const DefendantInformation = () => {
  return (
    <>
      <div className={`${styles['signature']}`}>
        <p className={styles['table-text']}>Defendant or Corporate Officer Signature</p>
        <p className={styles['table-text']}></p>
      </div>
      <div className={`${styles['signature-date']}`}>
        <p className={styles['table-text']}>Date</p>
      </div>
      <div className={`${styles['mailing-address-back-half']} ${styles['centered-flex']}`}>
        <p className={`${styles['no-margin']} ${styles['print-p']}`}>Current</p>
        <p className={`${styles['no-margin']} ${styles['print-p']}`}>Mailing</p>
        <p className={`${styles['no-margin']} ${styles['print-p']}`}>Address</p>
      </div>
      <div className={`${styles['street-back-half']}`}>
        <p className={styles['table-text']}>Street</p>
      </div>
      <div className={`${styles['city-back-half']}`}>
        <p className={styles['table-text']}>City, State, Zip</p>
      </div>

      <div className={`${styles['home-phone-back-half']}`}>
        <p className={styles['table-text']}>Home Phone</p>
      </div>
      <div className={`${styles['work-phone-back-half']}`}>
        <p className={styles['table-text']}>Work Phone</p>
      </div>


      <div className={`${styles['parent-info-back-half']} ${styles['centered-flex']}`}>
        <p className={`${styles['no-margin']} ${styles['print-p']}`}>Parent or</p>
        <p className={`${styles['no-margin']} ${styles['print-p']}`}>Guardian of</p>
        <p className={`${styles['no-margin']} ${styles['print-p']}`}>Defendant</p>
        <p className={`${styles['no-margin']} ${styles['print-p']}`}>Under 18</p>
        <p className={`${styles['no-margin']} ${styles['print-p']}`}>Years</p>
        <p className={`${styles['no-margin']} ${styles['print-p']}`}>of Age</p>
      </div>
      <div className={`${styles['parent-signature-back-half']}`}>
        <p className={styles['table-text']}>Signature</p>
      </div>
      <div className={`${styles['parent-date-back-half']}`}>
        <p className={styles['table-text']}>Date</p>
      </div>
      
      <div className={`${styles['parent-street-back-half']}`}>
       <p className={styles['table-text']}>Street</p>
      </div>
      <div className={`${styles['parent-home-phone-back-half']}`}>
       <p className={styles['table-text']}>Home Phone</p>
      </div>
      <div className={`${styles['parent-city-back-half']}`}>
       <p className={styles['table-text']}>City, State, Zip</p>
      </div>
      <div className={`${styles['parent-work-phone-back-half']}`}>
         <p className={styles['table-text']}>Work Phone</p>
      </div> 
      
      <div className={styles['home-phone-lines-container']}>
        {Array.from(Array(10).keys()).map((i) => {
          return (
            <p key={"home-phone-key-" + i} className={i<9 ? styles['phone-border'] : ""}></p>
          )
        })}
      </div>
      <div className={styles['work-phone-lines-container']}>
        {Array.from(Array(10).keys()).map((i) => {
          return (
            <p key={"work-phone-key-" + i} className={i<9 ? styles['phone-border'] : ""}></p>
          )
        })}
      </div>
      <div className={styles['parent-home-phone-lines-container']}>
        {Array.from(Array(10).keys()).map((i) => {
          return (
            <p key={"parent-home-phone-key-" + i} className={i<9 ? styles['phone-border'] : ""}></p>
          )
        })}
      </div>
      <div className={styles['parent-work-phone-lines-container']}>
        {Array.from(Array(10).keys()).map((i) => {
          return (
            <p key={"parent-work-phone-key-" + i} className={i<9 ? styles['phone-border'] : ""}></p>
          )
        })}
      </div>
    </>
  )
}
const SignHere = () => {
  return (
    <div className={styles['arrow-container']}>
      <p className={styles['print-p']}>1. Sign here </p>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <div className={styles['element-with-arrow']} ></div>
    </div>
  )
}

const CheckboxWithText = ({ children }) => {
  return (
    <div className={styles['checkbox-container']}>
      <div className={styles['print-checkbox']}></div>
      {children}
    </div>
  )

}

const DefendantPleaBottomText = () => {
  return (
    <div className={`${styles['back-bottom-half']}`} >
      <div className={`${styles['text-left-half']}`} >
        <p className={`${styles['print-p-textbox']}`}>
          &nbsp;IF YOU ACCEPT THE PENALTIES WITHOUT A HEARING: Mark your plea<br />
          and sign above. Deliver your plea to the Judicial Bureau within 21 days with<br />
          payment of the WAIVER AMOUNT shown on the front of the Complaint. Pay<br />
          by check or money order in U.S. funds, making checks payable to: <strong>JUDICIAL<br />
            BUREAU.  Judgment will be entered against you and any points and<br />
            suspension required by law will be imposed.</strong>  If you wish to accept the<br />
          penalties without a hearing but cannot pay the entire waiver amount, you may<br />
          pay $30.00 toward the penalty every 30 days until the penalty is paid in full. A<br />
          request for this accommodation must be made in writing. Additional<br />
          information about this payment plan is available at the Judicial Bureau<br />
          website: www.vermontjudiciary.org<br />
          &nbsp;IF YOU REQUEST A HEARING: Mark your plea and sign above. Deliver<br />
          your plea to the Judicial Bureau within 21 days. Your case will be scheduled<br />
          for a hearing. You will find more detailed information about participating in the<br />
          hearing on the back of the other copy of the complaint, which you should keep<br />
          for reference. If, at the hearing, you decide to enter a plea to the violation or<br />
          are found to have committed the alleged violation by the judge, the judge will<br />
          consider any evidence offered by you about your ability to pay the penalty.<br />
          &nbsp;YOU MUST PAY ONLINE OR DELIVER A PLEA WITHIN 21 DAYS:<br />
          Otherwise, judgment will be entered against you by default, any points and<br />
          suspension required by law will be imposed, and you will be liable for the<br />
          WAIVER AMOUNT, plus a $20.00 FAILURE TO ANSWER FEE. If you fail to<br />
          pay the WAIVER AMOUNT, you will be assessed a $30.00 FAILURE TO PAY<br />
          FEE and your hunting/fishing/trapping license may be suspended.<br />
        </p>
      </div>
      <div className={`${styles['text-right-half']}`} >
        <p className={`${styles['print-p-textbox']}`}>
          &nbsp;IF JUDGMENT IS ENTERED AGAINST YOU:<br />
          &nbsp;DMV POINTS SUSPENSIONS: You will be suspended for 10 days for 10<br />
          points, 30 days for 15 points, 90 days for 20 points, and an additional 30 days for<br />
          each additional 5 points, accumulated within 2 years. If you are found at fault for a<br />
          traffic accident resulting from a violation, then 2 points will be assessed in addition<br />
          to the amount shown on the face of this complaint. 23 V.S.A.<span className={`${styles['rotate']} ${styles['print-p-textbox']}`}>§</span>2502(b), 2506.<br />
          <br />
          &nbsp;VIOLATION SUSPENSIONS: Certain violations result in suspensions regardless<br />
          of points. These include misusing or counterfeiting plates or documents (23 V.S.A.<span className={`${styles['rotate']} ${styles['print-p-textbox']}`}>§</span><br />
          203); operating a motor vehicle at 0.02 or more alcohol concentration while under<br />
          21 years (23 V.S.A.<span className={`${styles['rotate']} ${styles['print-p-textbox']}`}>§</span>1216); possessing one ounce or less of marijuana while<br />
          under 21 years (18 V.S.A.<span className={`${styles['rotate']} ${styles['print-p-textbox']}`}>§</span>4230b); possessing, consuming or misrepresenting age<br />
          to procure alcohol while under 21 years (7 V.S.A.<span className={`${styles['rotate']} ${styles['print-p-textbox']}`}>§</span>656).<br />
          <br />
          &nbsp;JUNIOR OPERATORS/LEARNERS PERMITS: Your junior operator’s license<br />
          will be recalled for 30 days if you are adjudicated of a single texting violation (23<br />
          V.S.A.<span className={`${styles['rotate']} ${styles['print-p-textbox']}`}>§</span>1099); or 90 days any of the following: an adjudication of single<br />
          speeding violation resulting in a three-point assessment; the accumulation of a<br />
          total of six points; an adjudication of a passenger restriction violation (23 V.S.A.<span className={`${styles['rotate']} ${styles['print-p-textbox']}`}>§</span><br />
          614(c). Your learner’s permit will be recalled for 90 days for any adjudication of a<br />
          violation of 23 V.S.A.<span className={`${styles['rotate']} ${styles['print-p-textbox']}`}>§</span>615(a). (23 V.S.A.<span className={`${styles['rotate']} ${styles['print-p-textbox']}`}>§</span>607a(a))
        </p>
      </div>
    </div>
  )
}

export default DefendantPlea;
